import {useRef, useState,  useEffect, useCallback, useContext} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {VideoContext} from '../../../contexts/VideoContext'

import {FaPlay, FaPause} from 'react-icons/fa6'


const styles = {
  gradientButtonWrapper: css`
    display: flex;
    align-items: flex-start;
    background-color: black;
    overflow: hidden;
  `,
  gradientButton: css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: none;
    outline: none;
    position: relative;
    z-index: 1;
    height: 48px;
    min-width: 48px;
    border-radius: 50%;
    background: linear-gradient(to right, #ff0095, #fbde54, #DC1FFF);
    background-size: 100% 100%;
    cursor: pointer;
    color: white;
    text-transform: uppercase;
    animation: gradient-animation 3s ease 3;

    &::before {
      content: '';
      position: absolute;
      left: 3px;
      right: 3px;
      top: 3px;
      bottom: 3px;
      border-radius: 50%;
      background-color: black;
      height: 42px;
      z-index: -1;
      transition: 200ms;
    }

    &::after {
      font-size: 16px;
      background: linear-gradient(to left, #ff0095, #fbde54, #DC1FFF);
      -webkit-background-clip: text;
      color: transparent;
      transition: 200ms;
    }

    @keyframes gradient-animation {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `
}




const GradientPlayButton = ({ showText = false }) => {
  const {isPlaying, play, pause} = useContext(VideoContext)

  const handleClick = () => {
    isPlaying ? pause() : play()
  }

  return (
    <div css={styles.gradientButtonWrapper}>
      <button css={styles.gradientButton} onClick={handleClick}>
        {isPlaying
          ? <><FaPause /> {showText && 'pause'}</>
          : <><FaPlay  /> {showText && 'play'}</>
        }
      </button>
    </div>
  )
}



export default GradientPlayButton



